fragment TrainingCourseAdminFields on TrainingCourseAdmin {
  id
  title
  slug
  controlReference
  summary
  status
  position
  posterUrl
  category {
    id
    name
    archived
  }
  requirement
  audience
  teams {
    id
    name
    archived
  }
  audienceCount
  dueWithinDays
  renewalMonths
  renewalNoticeDays
  publishedAt
  publishedModuleCount
  updatedAt
  employees {
    id
    name
    email
    team {
      id
      name
    }
  }
  modules {
    id
    title
    slug
    controlReference
    status
    position
    hasVideo
    quizRequired
    unlocksAfterPrevious
    activeQuestionCount
    questionsPerAttempt
    updatedAt
  }
}
